/**
 * @fileoverview VenueSearchcomponent
 *
 * Membership Onboarding Journey
 */

import { render } from 'lit-html';

import Modal from '../../components/Modal';
import BankCards from '../../components/BankCards';
import { recommendedPlanTemplate, upgradeablePlansTemplate, packagesSummaryTemplate, upsellBoxTemplate } from './membership-cards-templates';

import { scrollToTop, getDataFromForm } from '../../utils/misc';
import attachValidation from '../../utils/form-validation';
import Request from '../../utils/request';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import dataLayer from '../../utils/data-layer';
import { getCookie } from '../../utils/cookiesManager';

class MembershipOnboardingResume {
	constructor() {
		this.state = {
			section: 0,
			data: {},
			availablePlans: [],
			selectedPlan: undefined,
			isAddOn: false
		};
		this._modal = undefined;
		this._mainModal = undefined;
		this._submitModal = undefined;
		this._sections = [];
		this._rules = [
			{
				target: 'isExistingMember',
				values: ['No'],
				action: 'skip-venue'
			}
		];
		this._cardsInitiated = false;
		this._paymentValidation = undefined;
		this._bankCards = undefined;
		this._isRecommended = false;
		this._submitPaymentCta = undefined;
		this.registrationInformation = {}; // this is for storing all the onboarding selected values so to push it to local storage to be accessed by verkeer.co for Google Analytics.
		this.analyticsCookie = undefined;
		this.initiateOnboarding();
	}

	initiateOnboarding() {
		const trigger = document.querySelector('.js-onboarding-trigger-resume');
		this._modal = document.querySelector('#onboarding-modal-resume');
		const closeModal = document.querySelector('#exit-onboarding-resume');

		if (trigger !== null && this._modal !== null) {
			this.getAnalyticsCookie();
			this._mainModal = new Modal(this._modal, {});

			this._submitModal = new Modal(document.querySelector('#submission-loading-resume'), { backdrop: 'static' });

			const exitModal = new Modal(closeModal, { backdrop: 'static' });
			const closeCtas = this._modal.querySelectorAll('.js-onboarding-close-resume');
			const continueCta = closeModal.querySelector('.js-onboarding-continue-resume');
			const exitCta = closeModal.querySelector('.js-onboarding-exit-resume');

			const previousCtas = this._modal.querySelectorAll('.js-onboarding-back-resume');
			const dismissError = this._modal.querySelector('.js-dismiss-submit-error-resume');
			this._sections = this._modal.querySelectorAll('.lta-onboarding-container');
			this._submitPaymentCta = SelectorEngine.findOne('.js-membership-creation');

			trigger.addEventListener('click', () => {
				this._mainModal.show();
				this.getRecommendedCards();

			});

			this._modal.addEventListener('cards', this.updateHasCards.bind(this));

			closeCtas.forEach((cta) => {
				cta.addEventListener('click', () => {
					if (this._isRecommended) {
						this._mainModal.hide();
						this.resetJourney();
					} else {
						exitModal.show();
					}
				});
			});

			previousCtas.forEach((cta) => {
				cta.addEventListener('click', () => {
					this.getPreviousPart();
				});
			});

			continueCta.addEventListener('click', () => {
				exitModal.hide();
			});

			exitCta.addEventListener('click', () => {
				exitModal.hide();
				this._mainModal.hide();
				this.resetJourney();
			});

			dismissError.addEventListener('click', () => {
				const errorPopup = document.querySelector('.lta-onboarding-submit--error');
				errorPopup.classList.add('u-hidden');
			});

			const finishCta = SelectorEngine.findOne('.js-continue-home');
			finishCta.addEventListener('click', (event) => {
				const url = event.currentTarget.dataset.target;
				window.location.href = url;
			});
		}
	}

	getAnalyticsCookie() {
		let myCookie = getCookie('cookieprefs');
		let decodedStr = decodeURIComponent(myCookie);
		let jsonObject = JSON.parse(decodedStr);

		const perfCookie = jsonObject.perf;
		this.analyticsCookie =  perfCookie == true ? 'granted' : 'denied';
	}

	updateHasCards(event) {
		this._submitPaymentCta.disabled = !event.detail.hasCards;
	}

	goToNextSection() {
		const currentPosition = this.state.section;
		if (currentPosition + 1 < this._sections.length) {
			this._sections.item(currentPosition).classList.add('u-hidden');
			this._sections.item(currentPosition + 1).classList.remove('u-hidden');
			this.state.section = this.state.section + 1;
			this._modal.scrollTop = 1;
			this.screenReaderNarrationFix();
		}
	}

	getPreviousPart() {
		const currentSection = this._sections.item(this.state.section);
		const sectionParts = currentSection.querySelectorAll('.js-lta-section-content-resume');
		if (sectionParts.length === 1 || !sectionParts.item(0).classList.contains('u-hidden')) {
			this.goToPreviousSection();
		} else {
			this.goToPreviousPart();
		}
	}

	handleEditPackage(event) {
		event.preventDefault();
		this.goToPreviousSection();
	}

	goToPreviousSection() {
		const currentPosition = this.state.section;
		if (currentPosition - 1 >= 0) {
			this._sections.item(currentPosition).classList.add('u-hidden');
			this._sections.item(currentPosition - 1).classList.remove('u-hidden');
			this.state.section = this.state.section - 1;
			this._modal.scrollTop = 1;
			this.screenReaderNarrationFix();
		}
	}

	goToNextPart(event) {
		const clickedButton = event.target;
		if (clickedButton.dataset.rule) {
			this.handleRules(clickedButton.dataset.rule);
		} else {
			const currentPart = clickedButton.closest('.js-lta-section-content-resume');
			const nextPart = currentPart.nextElementSibling;
			currentPart.classList.add('u-hidden');
			nextPart.classList.remove('u-hidden');
			this._modal.scrollTop = 1;
			this.screenReaderNarrationFix();
		}
	}

	goToPreviousPart() {
		const currentSection = this._sections.item(this.state.section);
		const sectionParts = currentSection.querySelectorAll('.js-lta-section-content-resume');
		let currentPart;
		sectionParts.forEach((part) => {
			if (!part.classList.contains('u-hidden')) {
				currentPart = part;
			}
		});
		currentPart.classList.add('u-hidden');
		currentPart.previousElementSibling.classList.remove('u-hidden');
		this._modal.scrollTop = 1;
		this.screenReaderNarrationFix();
	}

	// this is to prevent the screen reader from narrating outside the modal after changing from section
	screenReaderNarrationFix() {
		this._modal.focus();
	}

	resetJourney() {
		const currentPosition = this.state.section;
		if (currentPosition !== 0) {
			this._sections.item(currentPosition).classList.add('u-hidden');
			this._sections.item(0).classList.remove('u-hidden');
			this.state.section = 0;
		}

		this._sections.forEach((section) => {
			const parts = section.querySelectorAll('.js-lta-section-content-resume');
			parts.forEach((part, i) => {
				if (i === 0) {
					part.classList.remove('u-hidden');
				} else {
					part.classList.add('u-hidden');
				}
			});
		});

		sessionStorage.ltaOnboardingExit = true;
	}

	handleRules(rule) {
		switch (rule) {
			case 'redirect':
				this.ruleRedirect();
				break;

			case 'skip-venue':
				this.ruleSkipVenue();
				break;

			default:
				break;
		}
	}

	ruleRedirect() {
		this._mainModal.hide();
		this.resetJourney();
	}

	ruleSkipVenue() {
		this.goToNextSection();
	}

	showProcessing() {
		this._submitModal.hide();
		const errorPopup = document.querySelector('.lta-onboarding-submit--processing');
		errorPopup.classList.remove('u-hidden');
		scrollToTop();
	}

	showError(title) {
		this._submitModal.hide();
		const errorPopup = document.querySelector('.lta-onboarding-submit--error');
		const popupTitle = SelectorEngine.findOne('.title', errorPopup);
		popupTitle.innerHTML = title;
		errorPopup.classList.remove('u-hidden');
		scrollToTop();
	}

	renderAutoRecommendedCards(data) {
		const recommendedCardContainerElement = SelectorEngine.findOne('.js-recommended-plan-container-resume');
		const upgradeableCardContainerElement = SelectorEngine.findOne('.js-upgradeable-plan-container-resume');
		const upgradeableCardAttributes = Manipulator.getDataAttributes(upgradeableCardContainerElement);

		const recommendedCardTpl = recommendedPlanTemplate(data.RecommendedPlan, this.handlePackageSelection.bind(this));
		const upgradeableCardsTpl = upgradeablePlansTemplate(
			{ cardsData: { ...upgradeableCardAttributes }, plansData: data.UpgradeablePlans },
			this.handlePackageSelection.bind(this)
		);

		render(recommendedCardTpl, recommendedCardContainerElement);
		render(upgradeableCardsTpl, upgradeableCardContainerElement);
	}

	async getRecommendedCards() {
		const url = '/api/membership/planselection';

		const membershipResponse = await Request.get(url, this.state.data).catch(() => {
			this.goToNextSection();
			this.showError('We have had an error retrieving a membership for you');
		});

		const { RecommendedPlan, UpgradeablePlans, IsRecommended } = membershipResponse;
		this._isRecommended = IsRecommended;
		if (RecommendedPlan && UpgradeablePlans.length > 0) {
			this.renderAutoRecommendedCards(membershipResponse);
			this.storeAvailablePlans(membershipResponse);

			// Here we are pushing the onboard selected options and recommended membership to the dataLayer so that the Google tag manager can access them.

			const formData = {
				event: 'membership options selected', 
				analytics_storage: this.analyticsCookie, 
				...this.state.data};
			const plansForDataLayer = {
				event: 'Recommended memberships', 
				RecommendedPlan: `${RecommendedPlan.NamePrefix} ${RecommendedPlan.Name}`, 
				analytics_storage: this.analyticsCookie,};
			if (RecommendedPlan.AddOn) {
				plansForDataLayer.RecommendedPlanAddOn = `${RecommendedPlan.AddOn.NamePrefix} ${RecommendedPlan.AddOn.Name}`;
			} else {
				plansForDataLayer.RecommendedPlanAddOn = null;
			}
			plansForDataLayer.UpgreadablePlans = [];
			UpgradeablePlans.forEach((plan) => {
				plansForDataLayer.UpgreadablePlans.push({UpgradeablePlan: `${plan.NamePrefix} ${plan.Name}`});
			});
			dataLayer.push(formData);
			dataLayer.push(plansForDataLayer);
			this.registrationInformation = {...this.registrationInformation, ...formData, ...plansForDataLayer};
			// end of pushing the values to DataLayer.

			this.goToNextSection();

			const addonInput = SelectorEngine.findOne('#recommendedPlanAddonCheckbox');
			if (addonInput !== null) {
				addonInput.addEventListener('change', (e) => this.changeMainPackageId(e));
			}

		}

	}

	storeAvailablePlans(data) {
		const { RecommendedPlan, UpgradeablePlans } = data;
		this.state.availablePlans.push(RecommendedPlan);
		if (RecommendedPlan.AddOn) {
			this.state.availablePlans.push(RecommendedPlan.AddOn);
		}
		this.state.availablePlans = [...this.state.availablePlans, ...UpgradeablePlans];
	}

	changeMainPackageId(event) {
		const { value, checked } = event.target;
		const mainCta = SelectorEngine.findOne('.js-package-main');
		const { MembershipId, ContinueButtonText } = this.state.availablePlans[0];
		if (checked) {
			mainCta.dataset.package = value;
			mainCta.innerHTML = `${ContinueButtonText} (+ add-on)`;
			this.state.isAddOn = true;
		} else {
			mainCta.dataset.package = MembershipId;
			mainCta.innerHTML = ContinueButtonText;
			this.state.isAddOn = false;
		}
	}

	updatePackages(packageId) {
		this.state.selectedPlan = this.state.availablePlans.filter((plan) => plan.MembershipId === packageId)[0];

		const mebershipPaymentWrapper = SelectorEngine.findOne('.lta-membership-checkout--payments-method');
		if (this.state.selectedPlan.Price > 0) {
			if (!this._cardsInitiated) {
				this._bankCards = new BankCards('.js-membership-payments-options');
				this._cardsInitiated = true;
			}
			mebershipPaymentWrapper.classList.remove('u-hidden');
		} else {
			mebershipPaymentWrapper.classList.add('u-hidden');
		}

		const membershipTotal = SelectorEngine.findOne('.js-package-total');
		membershipTotal.innerHTML = this.state.selectedPlan.DisplayPrice;

		const packagesWrapper = SelectorEngine.findOne('.lta-membership-checkout--summary-packages');
		const packagesTemplate = packagesSummaryTemplate(
			this.state.selectedPlan,
			this.state.isAddOn,
			this.state.availablePlans,
			this.handleEditPackage.bind(this)
		);
		render(packagesTemplate, packagesWrapper);

		const upsellBox = SelectorEngine.findOne('.lta-membership-checkout--summary-add-upgrade');
		render(upsellBoxTemplate(this.state.selectedPlan, this.state.availablePlans, this.handleUpsellSelection.bind(this)), upsellBox);

		const freeMembershipCta = SelectorEngine.findOne('.js-free-membership-creation');
		if (this.state.selectedPlan.Price > 0) {
			this._submitPaymentCta.classList.remove('u-hidden');
			freeMembershipCta.classList.add('u-hidden');
		} else {
			this._submitPaymentCta.classList.add('u-hidden');
			freeMembershipCta.classList.remove('u-hidden');
		}
	}

	handleUpsellSelection(event) {
		const packageId = event.target.dataset.package;
		const [mainPlan] = this.state.availablePlans;
		if (mainPlan.AddOn && packageId === mainPlan.AddOn.MembershipId) {
			this.state.isAddOn = true;
		} else {
			this.state.isAddOn = false;
		}
		this.updatePackages(packageId);
	}

	handlePackageSelection(event) {
		const packageId = event.target.dataset.package;
		this.validatePaymentForm();
		this.updatePackages(packageId);

		const freeMembershipCta = SelectorEngine.findOne('.js-free-membership-creation');
		freeMembershipCta.addEventListener('click', () => { //after finalizing the membership we are pushing the selected plan to the dataLayer and local storage.
			// eslint-disable-next-line max-len
			const FinalizedMembershipDataLayer =  {
				event: 'membership sign-up completed', 
				SelectedPlan: `${this.state.selectedPlan.NamePrefix} ${this.state.selectedPlan.Name}`,
				Price: this.state.selectedPlan.DisplayPrice,
				analytics_storage: this.analyticsCookie,
			};
			dataLayer.push(FinalizedMembershipDataLayer);
			this.registrationInformation = {...this.registrationInformation, ...FinalizedMembershipDataLayer};
			localStorage.setItem('Registration-Information', JSON.stringify(this.registrationInformation));
			this.goToNextSection();
		});

		this.goToNextSection();
	}

	validatePaymentForm() {
		const paymentForm = SelectorEngine.findOne('#payment-methods-cards');
		const cardValidators = {
			validators: {
				notEmpty: {
					message: 'Please select one payment option below, or alternatively add a new payment type'
				}
			}
		};
		paymentForm.addEventListener('addCard', (event) => this.addFieldToValidation(event, cardValidators));
		this._paymentValidation = attachValidation(paymentForm, {
			CardTokenId: cardValidators
		});

		this._paymentValidation.on('core.form.valid', async () => {
			this._bankCards.showCards();
			const dataObject = getDataFromForm(paymentForm);

			if (dataObject.CardTokenId) {
				this._submitPaymentCta.disabled = true;
				
				const paymentRequest = await Request.post('/api/payments/pay', {
					Customer: {
						CustomerId: dataObject.CustomerId
					},
					OrderTotal: this.state.selectedPlan.Price,
					LineItems: [
						{
							ProductId: this.state.selectedPlan.SalesForceId
						}
					],
					PaymentMethod: {
						CardTokenId: dataObject.CardTokenId,
						RecurringPayment: true,
						RetainCard: true
					}
				})
				.catch(() => {
					this.showError('We have had an error processing your payment');
					this._submitPaymentCta.disabled = false;
				});

				switch(paymentRequest.Status) {
					case 'SUCCEEDED':
						this.finishOnboarding();
					  break;
					case 'PROCESSING':
						this.showProcessing();
					  break;
					case 'REQ_AUTHORIZATION':
						const { paymentIntent, error } = await this._bankCards._stripeLTA.confirmCardPayment(paymentRequest.ClientSecret)
						.catch(() => {
							this.showError('We were unable to confirm your card payment.', false);
							this._submitPaymentCta.disabled = false;
						});

						if (error) {
							this._bankCards.showError(error.message, false);
							this._submitPaymentCta.disabled = false;
							const cancelPayment =  await this._bankCards.captureCardPayment(error.payment_intent.id);
						} else {
							const capturePayment =  await this._bankCards.captureCardPayment(paymentIntent.id)
							.then((response) => {
								if(response.Status) {
									this.finishOnboarding();
								} else {
									this.showError('We were unable to confirm your card payment.', false);
									this._submitPaymentCta.disabled = false;
								}			
							}).catch(() => {
								this.showError('We were unable to confirm your card payment.', false);
								this._submitPaymentCta.disabled = false;
							});
						}
					  break;
					default:
						this.showError(paymentRequest.ErrorMessage);
						this._submitPaymentCta.disabled = false;
				}

				this._submitPaymentCta.disabled = false;
			}
		})
	}

	addFieldToValidation(event, validators) {
		this._paymentValidation.addField('CardTokenId', validators);
	}

	finishOnboarding() {
		//after finalizing the membership we are pushing the selected plan to the dataLayer and local storage.
		// eslint-disable-next-line max-len
		const FinalizedMembershipDataLayer = {
			event: 'membership sign-up completed', 
			SelectedPlan: `${this.state.selectedPlan.NamePrefix} ${this.state.selectedPlan.Name}`,
			Price: this.state.selectedPlan.DisplayPrice,
			analytics_storage: this.analyticsCookie,
		};
		dataLayer.push(FinalizedMembershipDataLayer);
		this.registrationInformation = { ...this.registrationInformation, ...FinalizedMembershipDataLayer };
		localStorage.setItem('Registration-Information', JSON.stringify(this.registrationInformation));
		this.goToNextSection();
	}
}

const globalOnboarding = new MembershipOnboardingResume();

export default globalOnboarding;
